import moment from 'moment';

export const DEFAULT_EXPIRATION_DATE_CARD_FORMAT = 'MM/YY';
export const DEFAULT_EXPIRATION_DATE_CARD_PARSE = 'MM/YY';

export const DEFAULT_CREDIT_CARD_EXPIRATION_DATE_MASK = '__/__';

export const formatCvv = (cvv: string) => {
  if (!cvv) return cvv;
  const digits = cvv.replace(/[^\d]/g, '');
  return digits.slice(0, 4);
};

export const formatCardNumber = (cardNumber: string) => {
  if (!cardNumber) return cardNumber;
  const digits = cardNumber.replace(/[^\d]/g, '');
  return digits.slice(0, 16);
};

export const parseDate = (date: string) => {
  if (!date) return date;
  return moment(date).format(DEFAULT_EXPIRATION_DATE_CARD_PARSE);
};

export const formatDate = (date: string) => {
  if (!date) return date;
  return moment(date).format(DEFAULT_EXPIRATION_DATE_CARD_FORMAT);
};
